import type { FaireProductEntity } from "../../entity_types/product";

export const p_ecg2yrpfqg: FaireProductEntity = {
  token: "p_ecg2yrpfqg",
  type: "product",
  name: "New England Foods Sticker Sheet - Vinyl, Waterproof, Die-Cut",
  brandToken: "b_2nlyab4cca",
  brandName: "Sarah Wormann Art",
  imageUrl: "https://cdn.faire.com/fastly/3dda57d15d3295cdb9306529f7c83615ffa1ba641e330ca95b8f0f71c66fa12a.jpeg",
  galleryImageUrls: [],
  priceDollars: 4,
  description: "5”x7” vinyl sticker sheet featuring some of the illustrations from my New England Foods print. Each sticker is individually die-cut, waterproof, and weatherproof. Jazz up water bottles, notebooks, sketchbook covers, cars, and more.\n\nIncludes 13 designs:\n• Del's lemonade\n• Hoodsie ice cream cup\n• Cape Cod chips\n• Saltwater taffy\n• Ben & Jerry's ice cream pint\n• Teddie's peanut butter\n• Maple creemee\n• Lobster roll\n• Table Talk pie\n• Autocrat coffee syrup\n• Polar seltzer\n• Marshmallow Fluff\n• Cider donut",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:52.240Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
